/** 로그인·관제 비밀번호 등 인증 전 화면 — 401 시 전역 리다이렉트 금지 */
export const AUTH_PUBLIC_PATHS = [
  '/verify-admin',
  '/login',
  '/register',
  '/reset-password',
] as const;

export function isAuthPublicPath(pathname?: string): boolean {
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  return AUTH_PUBLIC_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
}
